// extracted by mini-css-extract-plugin
module.exports = {"tabContentHeader":"Orders_tabContentHeader__1nhdz","pagination":"Orders_pagination__3v3WF","highlightRow":"Orders_highlightRow__9_awY"};